import React, { useEffect } from "react";
import "./Maintenance.css";
import logo from '../../Assests/6cc50dfbdb85cec604c94e003196fcb318fb231a.png'

const Maintenance = () => {
  useEffect(() => {
    const footer = document.querySelector(".footerContainer");
    if (footer) {
      footer.style.display = "none";
    }

    const nav = document.querySelector(".navContainer");
    if (nav) {
      nav.style.display = "none";
    }

    // Limpieza si sales de la vista
    return () => {
      if (footer) {
        footer.style.display = "";
      }
      if (nav) {
        nav.style.display = "";
      }
    };
  }, []);

  return (
    <div className="maintenance-container">
      <div className="maintenance-content">
        <img src={logo} alt="Logo de Rebornpty" className="logoMaintenace"/>
        <h1>Estamos en mantenimiento</h1>
        <p>Estamos trabajando para mejorar tu experiencia. Volveremos pronto.</p>
        <span className="maintenance-subtext">Gracias por tu paciencia.</span>
      </div>
    </div>
  );
};

export default Maintenance;
